export const actionTypes = {
  SAVE_RTK_CLIENT: 'SAVE_RTK_CLIENT',
};

export const saveRTKSDKClient = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_RTK_CLIENT,
    data: data,
  });
};

